/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DetailedCompanyCto } from '../../models/detailed-company-cto';

export interface GetCompany$Plain$Params {
  companyId: string;
}

export function getCompany$Plain(http: HttpClient, rootUrl: string, params: GetCompany$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DetailedCompanyCto>> {
  const rb = new RequestBuilder(rootUrl, getCompany$Plain.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DetailedCompanyCto>;
    })
  );
}

getCompany$Plain.PATH = '/company/{companyId}';
